import { db } from "./firebaseConfig";
import { collection, doc, getDocs, deleteDoc, setDoc } from "firebase/firestore";
import { getActiveGroupSlug } from "./firebaseService";

// Collection-Namen (ohne Prefix)
const BASE_COLLECTIONS = [
  "members",
  "assignments",
  "freikarten",
  "attendance",
  "courtAssignments",
  "court_start_times",
  "check_in_out",
  "essensmarken",
  "crews_on_court",
  "attendance_comment",
  "einkleidung",
  "einteilungen_public",
  "page_config",
  "billing_public",
  "polls",
  "crew_schedules",
];

const prefixed = (name, slug) => `${slug || getActiveGroupSlug()}__${name}`;

// Exportiert alle Daten einer Gruppe als Objekt
export const exportGroupData = async (slug) => {
  const allData = {};
  for (const baseName of BASE_COLLECTIONS) {
    const colName = prefixed(baseName, slug);
    try {
      const snapshot = await getDocs(collection(db, colName));
      if (!snapshot.empty) {
        allData[baseName] = snapshot.docs.map((d) => ({ _id: d.id, ...d.data() }));
      }
    } catch (e) {
      // Collection existiert nicht oder kein Zugriff - ueberspringen
    }
  }
  return allData;
};

// Loescht alle Dokumente aus allen Collections einer Gruppe
export const clearAllCollections = async (slug) => {
  try {
    for (const baseName of BASE_COLLECTIONS) {
      const colName = prefixed(baseName, slug);
      const colRef = collection(db, colName);
      const snapshot = await getDocs(colRef);

      if (!snapshot.empty) {
        const deletions = snapshot.docs.map((docSnap) => deleteDoc(doc(db, colName, docSnap.id)));
        await Promise.all(deletions);
      }
    }
  } catch (error) {
    console.error("Fehler beim Loeschen:", error);
    throw error;
  }
};

// Mitglieder hochladen und Verfuegbarkeit setzen
export const uploadBallkids = async (namesArray, daysArray) => {
  try {
    const membersCol = prefixed("members");
    const attendanceCol = prefixed("attendance");

    for (const name of namesArray) {
      const id = doc(collection(db, membersCol)).id;

      await setDoc(doc(db, membersCol, id), {
        name,
        jobs: 0,
        comments: [],
        assigned: {},
      });

      const availability = daysArray.reduce((acc, day) => ({ ...acc, [day]: true }), {});
      await setDoc(doc(db, attendanceCol, id), { availability });
    }
  } catch (error) {
    console.error("Fehler beim Hochladen:", error);
  }
};

// Einzelnes Mitglied hinzufuegen und Verfuegbarkeit setzen
export const addSingleBallkid = async (name, daysArray, email) => {
  const trimmed = (name || "").trim();
  if (!trimmed) {
    throw new Error("Name darf nicht leer sein.");
  }
  const trimmedEmail = (email || "").trim().toLowerCase();

  const membersCol = prefixed("members");
  const attendanceCol = prefixed("attendance");
  const id = doc(collection(db, membersCol)).id;

  const memberDoc = {
    name: trimmed,
    jobs: 0,
    comments: [],
    assigned: {},
  };
  if (trimmedEmail) {
    memberDoc.email = trimmedEmail;
  }
  await setDoc(doc(db, membersCol, id), memberDoc);

  const availability = (daysArray || []).reduce((acc, day) => ({ ...acc, [day]: true }), {});
  await setDoc(doc(db, attendanceCol, id), { availability });

  return id;
};
